import { createContext, use } from 'react';
import type { CycleSprint } from '@/data/cycles';

/** The open game's sprints, so task cards and history can name a task's sprint. */
export const SprintsContext = createContext<readonly CycleSprint[]>([]);

export function useSprintName(): (id: string | null | undefined) => string | null {
  const sprints = use(SprintsContext);
  return (id) => (id ? (sprints.find((s) => s.id === id)?.name ?? 'a sprint') : null);
}
